import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _URL_TYPES_VS_HEADERS;

import { serializeQuery } from 'axios-cache-adapter';
import _isFunction from 'lodash/isFunction';
import TEnvReader from '../../readers/Env';
import { generateRandomNumber } from '../../utils/general';
import { getValueFromSessionStorage } from '../../utils/sessionStorage';
import { URL_TYPES } from '../../constants/api';
import TRANSLATIONS_LS_CACHE_KEYS from '../../constants/translationsLSCacheKeys';
import { TEKION_SERVICES_VS_API_SERVICE, URL_TYPES_VS_TEKION_SERVICES } from './apiService.constants';
import { EMPTY_OBJECT } from '../../app.constants';
import apiCache, { API_CACHE_STORAGE_TYPE } from './apiCache';

var getDefaultCacheKey = function getDefaultCacheKey(request) {
  var headers = request.headers,
      params = request.params;
  var _ref = [headers.dealerId, headers.tenantname, headers['tek-siteId']],
      dealerId = _ref[0],
      tenantId = _ref[1],
      siteId = _ref[2];
  return "".concat(tenantId, "_").concat(dealerId, "_").concat(siteId, "_").concat(request.url, "_").concat(serializeQuery(params || EMPTY_OBJECT));
};

export var getDefaultHeader = function getDefaultHeader() {
  var userInfo = TEnvReader.userInfo();

  var _ref2 = userInfo || EMPTY_OBJECT,
      isWorkspace = _ref2.isWorkspace,
      workspaceId = _ref2.workspaceId;

  var currentLocale = getValueFromSessionStorage(TRANSLATIONS_LS_CACHE_KEYS.CURRENT_LOCALE);

  if (isWorkspace && (isWorkspace === 'true' || isWorkspace === true)) {
    return {
      'tekion-api-token': TEnvReader.apiToken(),
      roleId: userInfo.roleId,
      userId: userInfo.id,
      tenantname: userInfo.tenantName,
      tenantId: userInfo.tenantId,
      'original-userid': userInfo.originalUserId,
      'original-tenantid': userInfo.originalTenantId,
      clientId: 'web',
      isWorkspace: isWorkspace,
      enterpriseWorkspaceId: workspaceId,
      locale: currentLocale
    };
  }

  return {
    'tekion-api-token': TEnvReader.apiToken(),
    roleId: userInfo.roleId,
    userId: userInfo.id,
    tenantname: userInfo.tenantName,
    dealerId: userInfo.dealerId,
    tenantId: userInfo.tenantId,
    'original-userid': userInfo.originalUserId,
    'original-tenantid': userInfo.originalTenantId,
    clientId: 'web',
    'tek-siteId': userInfo.tekSiteId,
    locale: currentLocale
  };
};
export var getDSEHeader = function getDSEHeader() {
  var userInfo = TEnvReader.userInfo();
  if (TEnvReader.canMakeInternalCalls()) return getDefaultHeader();
  return {
    'tekion-api-token': TEnvReader.apiToken(),
    roleid: userInfo.roleId,
    tenantname: userInfo.tenantName,
    dealerid: userInfo.dealerId,
    clientid: 'web',
    'tek-siteId': userInfo.tekSiteId,
    correlationId: generateRandomNumber()
  };
};
export var getTekionDataHeader = function getTekionDataHeader() {
  return {
    'x-api-key': TEnvReader.tekionDataApiKey(process.env)
  };
};
export var URL_TYPES_VS_HEADERS = (_URL_TYPES_VS_HEADERS = {}, _defineProperty(_URL_TYPES_VS_HEADERS, URL_TYPES.CDMS, getDefaultHeader), _defineProperty(_URL_TYPES_VS_HEADERS, URL_TYPES.DSE, getDSEHeader), _defineProperty(_URL_TYPES_VS_HEADERS, URL_TYPES.TDP, getDSEHeader), _defineProperty(_URL_TYPES_VS_HEADERS, URL_TYPES.DATA, getTekionDataHeader), _defineProperty(_URL_TYPES_VS_HEADERS, URL_TYPES.STANDALONE, getDefaultHeader), _URL_TYPES_VS_HEADERS);
export var getCacheParams = function getCacheParams() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$cache = _ref3.cache,
      cache = _ref3$cache === void 0 ? false : _ref3$cache,
      _ref3$storageType = _ref3.storageType,
      storageType = _ref3$storageType === void 0 ? API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE : _ref3$storageType,
      setKey = _ref3.setKey;

  if (TEnvReader.isExportMode()) return {};
  return cache ? {
    exclude: {
      methods: ['patch', 'put', 'delete']
    },
    key: function key(req) {
      return {
        key: _isFunction(setKey) ? setKey(req) : getDefaultCacheKey(req),
        storageType: storageType
      };
    }
  } : {};
};
export var getCdmsBaseUrl = function getCdmsBaseUrl() {
  return TEnvReader.canMakeInternalCalls() ? "".concat(TEnvReader.internalEdgeUrl(), "/").concat(TEKION_SERVICES_VS_API_SERVICE.INTERNAL_SERVICE) : TEnvReader.cmdsUrl(process.env);
};
export var getCdmsUrl = function getCdmsUrl() {
  return TEnvReader.canMakeInternalCalls() ? "".concat(TEnvReader.internalEdgeUrl(), "/").concat(TEKION_SERVICES_VS_API_SERVICE.INTERNAL_SERVICE) : "".concat(TEnvReader.cmdsUrl(process.env)).concat(URL_TYPES_VS_TEKION_SERVICES.CDMS);
};
export var getDseUrl = function getDseUrl() {
  return TEnvReader.canMakeInternalCalls() ? "".concat(TEnvReader.internalEdgeUrl(), "/").concat(TEKION_SERVICES_VS_API_SERVICE.INTERNAL_SERVICE_DSE) : "".concat(TEnvReader.cmdsUrl(process.env)).concat(URL_TYPES_VS_TEKION_SERVICES.DSE);
};
export var getMediaUrl = function getMediaUrl() {
  return TEnvReader.canMakeInternalCalls() ? "".concat(TEnvReader.internalEdgeUrl(), "/").concat(TEKION_SERVICES_VS_API_SERVICE.INTERNAL_SERVICE, "/").concat(URL_TYPES_VS_TEKION_SERVICES.MEDIA) : "".concat(TEnvReader.cmdsUrl(process.env)).concat(URL_TYPES_VS_TEKION_SERVICES.MEDIA);
};
export var getTdpUrl = function getTdpUrl() {
  return "".concat(TEnvReader.tdpUrl(process.env)).concat(URL_TYPES_VS_TEKION_SERVICES.TDP);
};
export var cloudDataURL = function cloudDataURL() {
  return "".concat(TEnvReader.tekionDataUrl(process.env));
};
export var getStandaloneUrl = function getStandaloneUrl() {
  return TEnvReader.canMakeInternalCalls() ? "".concat(TEnvReader.internalEdgeUrl(), "/").concat(TEKION_SERVICES_VS_API_SERVICE.INTERNAL_SERVICE) : "".concat(TEnvReader.cmdsUrl(process.env)).concat(URL_TYPES_VS_TEKION_SERVICES.STANDALONE);
};
export var clearAllAPICacheStorage = function clearAllAPICacheStorage() {
  return apiCache.store.clear({
    storageTypesSet: new Set([API_CACHE_STORAGE_TYPE.IN_MEMORY_STORAGE, API_CACHE_STORAGE_TYPE.LOCAL_STORAGE])
  });
};